import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Ripple, initTE } from "tw-elements";
import Refresh from "../../Components/Refresh/Refresh";
import ResetPasswordPopup from "Popups/ResetPasswordPopup/ResetPasswordPopup";
import { setStatusData } from "../../Redux/DataSlice/DataSlice";
import api from "http";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import GlobalSearch from "./GlobalSearch/GlobalSearch";
import UserProfilePopup from "Popups/UserProfilePopup/UserProfilePopup";
import QuickActions from "Common/QuickActions/QuickActions";
import SettingsTab from "Common/SettingsTab/SettingsTab";
import AppStore from "Common/AppStore/AppStore";
import { CircleHelp } from "lucide-react";


const Header = ({ mainTabs, activeTab, onItemClick }) => {
  const [resetPopup, setResetPopup] = useState(false);
  const { userinfo } = useSelector((state) => state.userAuth);
  const [profilePopup, setProfilePopup] = useState(false)
  const dispatch = useDispatch();
  const globalSearchRight = useSelector((state) => state.userAuth.userinfo?.userModuleRights)?.globalsearch;

  const openResetPopup = () => {
    setResetPopup(true);
  }

  const closeResetPopup = () => {
    setResetPopup(false);
  }
  const onHandleLogout = () => {
    window.location.reload();

  }

  const onOpenProfilePopup = () => {
    setProfilePopup(true)
  }
  const onCloseProfilePopup = () => {
    setProfilePopup(false)
  }

  const getDropDown = useCallback(async () => {
    try {
      const resp = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisitStatusCodes`);
      dispatch(setStatusData({ dataModel: resp.data.dataModel }));
    } catch (error) {
      ErrorHandlingMessage(error);
    }
  }, [dispatch]);


  useEffect(() => {
    initTE({ Dropdown, Ripple });
  }, [])

  useEffect(() => {
    (async () => {
      try {
        await getDropDown();
      } catch (error) {
        ErrorHandlingMessage(error)
      }

    })();

  }, [dispatch, getDropDown])


  return (
    <>
      {resetPopup && <ResetPasswordPopup onClose={closeResetPopup} />}
      {profilePopup && <UserProfilePopup onClose={onCloseProfilePopup} />}
      <header className="sticky top-0 z-[3] flex items-center justify-between h-16 px-4 bg-white ">
        {globalSearchRight && <GlobalSearch />}
        <div className="flex items-center">
          <div className="flex items-center gap-1">
            <AppStore />
            <a
              href="https://www.notion.so/External-Shared-Trucare-Support-Docs-21efde8e6a4a8009977dd6968f075df3"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-8 w-8 items-center justify-center rounded-md text-[#889AB3] outline-none transition-colors duration-150 hover:bg-[#F3F4F7] hover:text-[#404D60]"
              aria-label="Open help documentation"
            >
              <CircleHelp size={16} strokeWidth={1.7} />
            </a>
            <Refresh />
            <SettingsTab mainTabs={mainTabs} activeTab={activeTab} onItemClick={onItemClick} />
            <QuickActions />
          </div>

        </div>
      </header >
    </>

  );
};

export default Header;